import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { chassisType } from 'src/app/core/constants/ChassisType';
import { fuelType, FuelTypeEnum } from 'src/app/core/constants/FuelType';
import { GetValuesService } from 'src/app/core/services/get-values.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { VehicleInformationResponse } from 'src/app/pages/new-service/interfaces/VehicleInformationResponse';
import { FunnelService } from 'src/app/pages/new-service/services/funnel.service';

export interface VechicleInformation {
  brand?: string;
  model?: string;
  licensePlate?: string;
  chassisType?: string;
  chassisTypeId: number;
  fuelType?: number;
  fuelTypeId?: number;
  icon?: string;
}


@Component({
  selector: 'app-vehicle-information-input',
  templateUrl: './vehicle-information-input.component.html',
  styleUrls: ['./vehicle-information-input.component.scss']
})
export class VehicleInformationInputComponent {

  @Input() VehicleData: VechicleInformation | undefined;
  @Input() ShowVehicleCard: boolean = false;
  @Input() ShowVehicleTitle: boolean = false;
  @Output() vehicleDataEmitter = new EventEmitter();

  VehicleForm!: FormGroup;
  licensePlate: string = "";
  searchError: boolean = false;
  isAddingManually: boolean = false;

  chassisType = chassisType;
  chassisTypeIdArray = Object.keys(chassisType);

  FuelTypeEnum = FuelTypeEnum;
  FuelTypeEnumArray = Object.values(FuelTypeEnum).filter(
    value => typeof value === 'number'
  );

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private loader: LoaderService, private funnelService: FunnelService, private translate: TranslateService, private getValuesService: GetValuesService) { }
  ngOnInit() {
    if (this.VehicleData) {
      this.setForm(this.VehicleData);
      this.VehicleForm.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe((newValue) => {
          this.formValueEmit();
        });

      if (this.VehicleData.licensePlate && this.VehicleData.licensePlate.length > 0) {
        this.licensePlate = this.VehicleData.licensePlate[0];
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next(); // Emite un valor para que takeUntil desuscriba
    this.destroy$.complete(); // Completa el Subject
  }

  setForm(VehicleData: VechicleInformation | undefined) {
    this.VehicleForm = new FormGroup({
      brand: new FormControl(VehicleData?.brand, Validators.required),
      model: new FormControl(VehicleData?.model, Validators.required),
      licensePlate: new FormControl(VehicleData?.licensePlate, Validators.required),
      chassisType: new FormControl(VehicleData?.chassisType),
      chassisTypeId: new FormControl(VehicleData?.chassisTypeId, Validators.required),
      fuelType: new FormControl(VehicleData?.fuelType),
      fuelTypeId: new FormControl(VehicleData?.fuelTypeId, Validators.required),
      icon: new FormControl(VehicleData?.icon),
    })
  }

  searchByLicensePlate() {
    // this.addLicensePlate();
    this.loader.show();
    this.funnelService.getVehicleData(this.licensePlate.split(' ').join('')).subscribe({
      next: (data: VehicleInformationResponse) => {
        this.VehicleForm.setValue({
          brand: data.Brand || '',
          model: data.Model || '',
          licensePlate: [data.LicensePlate || ''],
          chassisType: data.ChassisType !== undefined
            ? this.getValuesService.getChassisTypeString(data.ChassisType)
            : this.translate.instant('undefined'),
          chassisTypeId: data.ChassisType,
          fuelType: data.FuelType !== undefined
            ? this.getValuesService.getFuelTypeString(data.FuelType)
            : this.translate.instant('undefined'),
          fuelTypeId: data.FuelType !== undefined ? data.FuelType : null,
          icon: data.ChassisType !== undefined
            ? this.getValuesService.getChassisTypeIcon(data.ChassisType)
            : 'default-icon-path',
        });
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error loading vehicle data', error);
        this.loader.hide();
      },
    });
  }

  handleEnter(event: Event) { }

  formValueEmit() {
    this.vehicleDataEmitter.emit(this.VehicleForm.value);
  }

  toggleForm() {
    this.isAddingManually = !this.isAddingManually;
  }


  fuelTypeChange(event: any) {
    this.VehicleForm.patchValue({
      fuelTypeId: event,
      fuelType: fuelType[event]

    })
  }

  chassisTypeChange(event: any) {
    this.VehicleForm.patchValue({
      chassisTypeId: event,
      chassisType: chassisType[event].description

    })
  }
}
